/* tslint:disable */
/* eslint-disable */
/**
 * SCS-Official-BE
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * 
 * @export
 * @interface ArticleDto
 */
export interface ArticleDto {
    /**
     * 
     * @type {number}
     * @memberof ArticleDto
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof ArticleDto
     */
    'createdTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof ArticleDto
     */
    'deletedTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ArticleDto
     */
    'restoredTime'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ArticleDto
     */
    'isDelete'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ArticleDto
     */
    'title'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ArticleDto
     */
    'description'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ArticleDto
     */
    'content'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ArticleDto
     */
    'author'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ArticleDto
     */
    'department'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ArticleDto
     */
    'publishedDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof ArticleDto
     */
    'coverPath'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ArticleDto
     */
    'catalogs'?: string | null;
    /**
     * 
     * @type {UserDto}
     * @memberof ArticleDto
     */
    'uploader'?: UserDto;
    /**
     * 
     * @type {Array<AttachmentDto>}
     * @memberof ArticleDto
     */
    'attachments'?: Array<AttachmentDto> | null;
    /**
     * 
     * @type {ArticleStatus}
     * @memberof ArticleDto
     */
    'status'?: ArticleStatus;
}


/**
 * 
 * @export
 * @interface ArticleDtoSearchResponseDto
 */
export interface ArticleDtoSearchResponseDto {
    /**
     * 
     * @type {Array<ArticleDto>}
     * @memberof ArticleDtoSearchResponseDto
     */
    'list'?: Array<ArticleDto> | null;
    /**
     * 
     * @type {number}
     * @memberof ArticleDtoSearchResponseDto
     */
    'total'?: number;
}
/**
 * 
 * @export
 * @enum {string}
 */

export enum ArticleStatus {
    隐藏 = '隐藏',
    公开 = '公开',
    待审 = '待审'
}


/**
 * 
 * @export
 * @interface AttachmentDto
 */
export interface AttachmentDto {
    /**
     * 
     * @type {number}
     * @memberof AttachmentDto
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof AttachmentDto
     */
    'createdTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof AttachmentDto
     */
    'deletedTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AttachmentDto
     */
    'restoredTime'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof AttachmentDto
     */
    'isDelete'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof AttachmentDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AttachmentDto
     */
    'path'?: string | null;
}
/**
 * 
 * @export
 * @interface AuthorizeLoginByTelParams
 */
export interface AuthorizeLoginByTelParams {
    /**
     * 
     * @type {string}
     * @memberof AuthorizeLoginByTelParams
     */
    'telephone': string;
    /**
     * 
     * @type {string}
     * @memberof AuthorizeLoginByTelParams
     */
    'code': string;
}
/**
 * 
 * @export
 * @interface AuthorizeLoginParams
 */
export interface AuthorizeLoginParams {
    /**
     * 
     * @type {string}
     * @memberof AuthorizeLoginParams
     */
    'telephone': string;
    /**
     * 
     * @type {string}
     * @memberof AuthorizeLoginParams
     */
    'password': string;
}
/**
 * 
 * @export
 * @interface BatchImportDoubleMemberModel
 */
export interface BatchImportDoubleMemberModel {
    /**
     * 
     * @type {Array<ImportDoubleMemberModel>}
     * @memberof BatchImportDoubleMemberModel
     */
    'models'?: Array<ImportDoubleMemberModel> | null;
}
/**
 * 
 * @export
 * @interface CongressTable
 */
export interface CongressTable {
    /**
     * 
     * @type {string}
     * @memberof CongressTable
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CongressTable
     */
    'gender'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CongressTable
     */
    'source'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CongressTable
     */
    'birthDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof CongressTable
     */
    'job'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CongressTable
     */
    'organizationName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CongressTable
     */
    'organizationJob'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CongressTable
     */
    'workDepartment'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CongressTable
     */
    'workTitle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CongressTable
     */
    'organizationAddress'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CongressTable
     */
    'email'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CongressTable
     */
    'telephone'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CongressTable
     */
    'fax'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CongressTable
     */
    'postcode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CongressTable
     */
    'phone'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CongressTable
     */
    'advice'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CongressTable
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof CongressTable
     */
    'createdTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof CongressTable
     */
    'deletedTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CongressTable
     */
    'restoredTime'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CongressTable
     */
    'isDelete'?: boolean;
}
/**
 * 
 * @export
 * @interface CongressTableSearchResponse
 */
export interface CongressTableSearchResponse {
    /**
     * 
     * @type {Array<CongressTable>}
     * @memberof CongressTableSearchResponse
     */
    'list'?: Array<CongressTable> | null;
    /**
     * 
     * @type {number}
     * @memberof CongressTableSearchResponse
     */
    'total'?: number;
}
/**
 * 
 * @export
 * @interface CopyArticleParams
 */
export interface CopyArticleParams {
    /**
     * 
     * @type {string}
     * @memberof CopyArticleParams
     */
    'catalogs': string;
    /**
     * 
     * @type {number}
     * @memberof CopyArticleParams
     */
    'id'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof CopyArticleParams
     */
    'isUpdate'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CopyArticleParams
     */
    'isAdd'?: boolean;
}
/**
 * 
 * @export
 * @interface DoubleMemberImportRecordDto
 */
export interface DoubleMemberImportRecordDto {
    /**
     * 
     * @type {number}
     * @memberof DoubleMemberImportRecordDto
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof DoubleMemberImportRecordDto
     */
    'createdTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof DoubleMemberImportRecordDto
     */
    'deletedTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DoubleMemberImportRecordDto
     */
    'restoredTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DoubleMemberImportRecordDto
     */
    'email'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DoubleMemberImportRecordDto
     */
    'telephone'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DoubleMemberImportRecordDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DoubleMemberImportRecordDto
     */
    'verificationCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DoubleMemberImportRecordDto
     */
    'paidTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DoubleMemberImportRecordDto
     */
    'registeredTime'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DoubleMemberImportRecordDto
     */
    'userId'?: number | null;
    /**
     * 
     * @type {UserDto}
     * @memberof DoubleMemberImportRecordDto
     */
    'user'?: UserDto;
    /**
     * 
     * @type {string}
     * @memberof DoubleMemberImportRecordDto
     */
    'originalExpireTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DoubleMemberImportRecordDto
     */
    'newExpireTime'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DoubleMemberImportRecordDto
     */
    'addYear'?: number;
    /**
     * 
     * @type {number}
     * @memberof DoubleMemberImportRecordDto
     */
    'smsCount'?: number;
}
/**
 * 
 * @export
 * @interface DoubleMemberRegisterModel
 */
export interface DoubleMemberRegisterModel {
    /**
     * 
     * @type {number}
     * @memberof DoubleMemberRegisterModel
     */
    'recordId': number;
    /**
     * 
     * @type {number}
     * @memberof DoubleMemberRegisterModel
     */
    'userId': number;
}
/**
 * 
 * @export
 * @interface FindParams
 */
export interface FindParams {
    /**
     * 
     * @type {number}
     * @memberof FindParams
     */
    'id': number;
}
/**
 * 
 * @export
 * @interface GetPaymentUrlParams
 */
export interface GetPaymentUrlParams {
    /**
     * 
     * @type {PaymentGood}
     * @memberof GetPaymentUrlParams
     */
    'paymentGood': PaymentGood;
}


/**
 * 
 * @export
 * @interface ImportDoubleMemberModel
 */
export interface ImportDoubleMemberModel {
    /**
     * 
     * @type {string}
     * @memberof ImportDoubleMemberModel
     */
    'email'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ImportDoubleMemberModel
     */
    'telephone'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ImportDoubleMemberModel
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof ImportDoubleMemberModel
     */
    'addYear'?: number;
    /**
     * 
     * @type {string}
     * @memberof ImportDoubleMemberModel
     */
    'paidTime'?: string | null;
}
/**
 * 
 * @export
 * @interface ImportUserParams
 */
export interface ImportUserParams {
    /**
     * 
     * @type {string}
     * @memberof ImportUserParams
     */
    'telephone'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ImportUserParams
     */
    'password'?: string | null;
    /**
     * 
     * @type {MemberLevel}
     * @memberof ImportUserParams
     */
    'memberLevel'?: MemberLevel;
    /**
     * 
     * @type {string}
     * @memberof ImportUserParams
     */
    'registeredTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof ImportUserParams
     */
    'memberExpiredTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ImportUserParams
     */
    'memberNo'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ImportUserParams
     */
    'userId': number;
    /**
     * 
     * @type {string}
     * @memberof ImportUserParams
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof ImportUserParams
     */
    'nationality': string;
    /**
     * 
     * @type {string}
     * @memberof ImportUserParams
     */
    'identificationCardNo': string;
    /**
     * 
     * @type {string}
     * @memberof ImportUserParams
     */
    'gender'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ImportUserParams
     */
    'avatarPath'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ImportUserParams
     */
    'birthDate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ImportUserParams
     */
    'party': string;
    /**
     * 
     * @type {string}
     * @memberof ImportUserParams
     */
    'nativePlace'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ImportUserParams
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof ImportUserParams
     */
    'organizationFullTime': string;
    /**
     * 
     * @type {string}
     * @memberof ImportUserParams
     */
    'organizationDepartmentFullTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ImportUserParams
     */
    'positionFullTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ImportUserParams
     */
    'levelFullTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ImportUserParams
     */
    'organizationPartTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ImportUserParams
     */
    'organizationDepartmentPartTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ImportUserParams
     */
    'positionPartTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ImportUserParams
     */
    'levelPartTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ImportUserParams
     */
    'schoolDomestic': string;
    /**
     * 
     * @type {string}
     * @memberof ImportUserParams
     */
    'schoolDepartmentDomestic': string;
    /**
     * 
     * @type {string}
     * @memberof ImportUserParams
     */
    'schoolDateRangeDomestic': string;
    /**
     * 
     * @type {string}
     * @memberof ImportUserParams
     */
    'graduationDomestic': string;
    /**
     * 
     * @type {string}
     * @memberof ImportUserParams
     */
    'degreeDomestic': string;
    /**
     * 
     * @type {string}
     * @memberof ImportUserParams
     */
    'schoolAboard'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ImportUserParams
     */
    'schoolDepartmentAboard'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ImportUserParams
     */
    'schoolDateRangeAboard'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ImportUserParams
     */
    'graduationAboard'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ImportUserParams
     */
    'degreeAboard'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ImportUserParams
     */
    'schoolAmateur'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ImportUserParams
     */
    'schoolDepartmentAmateur'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ImportUserParams
     */
    'schoolDateRangeAmateur'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ImportUserParams
     */
    'graduationAmateur'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ImportUserParams
     */
    'degreeAmateur'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ImportUserParams
     */
    'organizationUndergo01'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ImportUserParams
     */
    'positionUndergo01'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ImportUserParams
     */
    'dateRangeUndergo01'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ImportUserParams
     */
    'locationUndergo01'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ImportUserParams
     */
    'organizationUndergo02'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ImportUserParams
     */
    'positionUndergo02'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ImportUserParams
     */
    'dateRangeUndergo02'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ImportUserParams
     */
    'locationUndergo02'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ImportUserParams
     */
    'organizationUndergo03'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ImportUserParams
     */
    'positionUndergo03'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ImportUserParams
     */
    'dateRangeUndergo03'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ImportUserParams
     */
    'locationUndergo03'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ImportUserParams
     */
    'organizationAddress01'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ImportUserParams
     */
    'organizationTel01'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ImportUserParams
     */
    'organizationPostcode01'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ImportUserParams
     */
    'organizationAddress02'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ImportUserParams
     */
    'organizationTel02'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ImportUserParams
     */
    'organizationPostcode02'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ImportUserParams
     */
    'massOrganizationPosition'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ImportUserParams
     */
    'techOrganizationPosition'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ImportUserParams
     */
    'foreignLanguageLevel'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ImportUserParams
     */
    'specialty'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ImportUserParams
     */
    'mainSpecialCommittee': string;
    /**
     * 
     * @type {string}
     * @memberof ImportUserParams
     */
    'subSpecialCommittee01'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ImportUserParams
     */
    'subSpecialCommittee02'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ImportUserParams
     */
    'currentDegree'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ImportUserParams
     */
    'currentSchool'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ImportUserParams
     */
    'currentTeacher'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ImportUserParams
     */
    'studentImagePath'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ImportUserParams
     */
    'remark'?: string | null;
}


/**
 * 
 * @export
 * @enum {string}
 */

export enum MemberLevel {
    未缴费 = '未缴费',
    普通会员 = '普通会员',
    学生会员 = '学生会员',
    双选会员 = '双选会员'
}


/**
 * 
 * @export
 * @interface PaymentDto
 */
export interface PaymentDto {
    /**
     * 
     * @type {number}
     * @memberof PaymentDto
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof PaymentDto
     */
    'createdTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof PaymentDto
     */
    'deletedTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PaymentDto
     */
    'restoredTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PaymentDto
     */
    'outTradeNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PaymentDto
     */
    'codeUrl'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof PaymentDto
     */
    'userId'?: number;
    /**
     * 
     * @type {UserDto}
     * @memberof PaymentDto
     */
    'user'?: UserDto;
    /**
     * 
     * @type {PaymentGood}
     * @memberof PaymentDto
     */
    'paymentGood'?: PaymentGood;
    /**
     * 
     * @type {number}
     * @memberof PaymentDto
     */
    'price'?: number;
    /**
     * 
     * @type {string}
     * @memberof PaymentDto
     */
    'paidTime'?: string | null;
    /**
     * 
     * @type {PaymentStatus}
     * @memberof PaymentDto
     */
    'status'?: PaymentStatus;
    /**
     * 
     * @type {string}
     * @memberof PaymentDto
     */
    'originalExpireTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PaymentDto
     */
    'afterExpireTime'?: string | null;
}


/**
 * 
 * @export
 * @interface PaymentDtoSearchResponseDto
 */
export interface PaymentDtoSearchResponseDto {
    /**
     * 
     * @type {Array<PaymentDto>}
     * @memberof PaymentDtoSearchResponseDto
     */
    'list'?: Array<PaymentDto> | null;
    /**
     * 
     * @type {number}
     * @memberof PaymentDtoSearchResponseDto
     */
    'total'?: number;
}
/**
 * 
 * @export
 * @enum {string}
 */

export enum PaymentGood {
    一年 = '一年',
    二年 = '二年',
    三年 = '三年',
    四年 = '四年',
    五年 = '五年',
    永久 = '永久',
    学生会员一年 = '学生会员一年',
    双选会员一年 = '双选会员一年'
}


/**
 * 
 * @export
 * @enum {string}
 */

export enum PaymentStatus {
    未支付 = '未支付',
    已退款 = '已退款',
    已支付 = '已支付',
    已关闭 = '已关闭'
}


/**
 * 
 * @export
 * @interface PersonalApprove
 */
export interface PersonalApprove {
    /**
     * 
     * @type {string}
     * @memberof PersonalApprove
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PersonalApprove
     */
    'nationality'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PersonalApprove
     */
    'identificationCardNo'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PersonalApprove
     */
    'gender'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PersonalApprove
     */
    'avatarPath'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PersonalApprove
     */
    'birthDate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PersonalApprove
     */
    'party'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PersonalApprove
     */
    'nativePlace'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PersonalApprove
     */
    'email'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PersonalApprove
     */
    'organizationFullTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PersonalApprove
     */
    'organizationDepartmentFullTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PersonalApprove
     */
    'positionFullTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PersonalApprove
     */
    'levelFullTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PersonalApprove
     */
    'organizationPartTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PersonalApprove
     */
    'organizationDepartmentPartTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PersonalApprove
     */
    'positionPartTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PersonalApprove
     */
    'levelPartTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PersonalApprove
     */
    'schoolDomestic'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PersonalApprove
     */
    'schoolDepartmentDomestic'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PersonalApprove
     */
    'schoolDateRangeDomestic'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PersonalApprove
     */
    'graduationDomestic'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PersonalApprove
     */
    'degreeDomestic'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PersonalApprove
     */
    'schoolAboard'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PersonalApprove
     */
    'schoolDepartmentAboard'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PersonalApprove
     */
    'schoolDateRangeAboard'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PersonalApprove
     */
    'graduationAboard'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PersonalApprove
     */
    'degreeAboard'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PersonalApprove
     */
    'schoolAmateur'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PersonalApprove
     */
    'schoolDepartmentAmateur'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PersonalApprove
     */
    'schoolDateRangeAmateur'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PersonalApprove
     */
    'graduationAmateur'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PersonalApprove
     */
    'degreeAmateur'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PersonalApprove
     */
    'organizationUndergo01'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PersonalApprove
     */
    'positionUndergo01'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PersonalApprove
     */
    'dateRangeUndergo01'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PersonalApprove
     */
    'locationUndergo01'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PersonalApprove
     */
    'organizationUndergo02'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PersonalApprove
     */
    'positionUndergo02'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PersonalApprove
     */
    'dateRangeUndergo02'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PersonalApprove
     */
    'locationUndergo02'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PersonalApprove
     */
    'organizationUndergo03'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PersonalApprove
     */
    'positionUndergo03'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PersonalApprove
     */
    'dateRangeUndergo03'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PersonalApprove
     */
    'locationUndergo03'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PersonalApprove
     */
    'organizationAddress01'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PersonalApprove
     */
    'organizationTel01'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PersonalApprove
     */
    'organizationPostcode01'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PersonalApprove
     */
    'organizationAddress02'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PersonalApprove
     */
    'organizationTel02'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PersonalApprove
     */
    'organizationPostcode02'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PersonalApprove
     */
    'massOrganizationPosition'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PersonalApprove
     */
    'techOrganizationPosition'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PersonalApprove
     */
    'foreignLanguageLevel'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PersonalApprove
     */
    'specialty'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PersonalApprove
     */
    'mainSpecialCommittee'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PersonalApprove
     */
    'subSpecialCommittee01'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PersonalApprove
     */
    'subSpecialCommittee02'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PersonalApprove
     */
    'currentDegree'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PersonalApprove
     */
    'currentSchool'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PersonalApprove
     */
    'currentTeacher'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PersonalApprove
     */
    'studentImagePath'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PersonalApprove
     */
    'remark'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof PersonalApprove
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof PersonalApprove
     */
    'createdTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof PersonalApprove
     */
    'deletedTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PersonalApprove
     */
    'restoredTime'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof PersonalApprove
     */
    'isDelete'?: boolean;
}
/**
 * 
 * @export
 * @interface RegisterParams
 */
export interface RegisterParams {
    /**
     * 
     * @type {string}
     * @memberof RegisterParams
     */
    'telephone': string;
    /**
     * 
     * @type {string}
     * @memberof RegisterParams
     */
    'password': string;
    /**
     * 
     * @type {string}
     * @memberof RegisterParams
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof RegisterParams
     */
    'passwordAgain': string;
}
/**
 * 
 * @export
 * @interface RequestSmsCodeParams
 */
export interface RequestSmsCodeParams {
    /**
     * 
     * @type {string}
     * @memberof RequestSmsCodeParams
     */
    'telephone': string;
}
/**
 * 
 * @export
 * @interface SaveArticleParams
 */
export interface SaveArticleParams {
    /**
     * 
     * @type {string}
     * @memberof SaveArticleParams
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof SaveArticleParams
     */
    'description'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SaveArticleParams
     */
    'content': string;
    /**
     * 
     * @type {string}
     * @memberof SaveArticleParams
     */
    'author'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SaveArticleParams
     */
    'department'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SaveArticleParams
     */
    'publishedDate': string;
    /**
     * 
     * @type {string}
     * @memberof SaveArticleParams
     */
    'coverPath'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SaveArticleParams
     */
    'catalogs': string;
    /**
     * 
     * @type {Array<SaveAttachmentParams>}
     * @memberof SaveArticleParams
     */
    'attachmentList'?: Array<SaveAttachmentParams> | null;
    /**
     * 
     * @type {number}
     * @memberof SaveArticleParams
     */
    'id'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof SaveArticleParams
     */
    'isUpdate'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SaveArticleParams
     */
    'isAdd'?: boolean;
}
/**
 * 
 * @export
 * @interface SaveAttachmentParams
 */
export interface SaveAttachmentParams {
    /**
     * 
     * @type {string}
     * @memberof SaveAttachmentParams
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof SaveAttachmentParams
     */
    'path': string;
}
/**
 * 
 * @export
 * @interface SaveCongressTableParams
 */
export interface SaveCongressTableParams {
    /**
     * 
     * @type {number}
     * @memberof SaveCongressTableParams
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof SaveCongressTableParams
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof SaveCongressTableParams
     */
    'gender': string;
    /**
     * 
     * @type {string}
     * @memberof SaveCongressTableParams
     */
    'birthDate': string;
    /**
     * 
     * @type {string}
     * @memberof SaveCongressTableParams
     */
    'job': string;
    /**
     * 
     * @type {string}
     * @memberof SaveCongressTableParams
     */
    'organizationName': string;
    /**
     * 
     * @type {string}
     * @memberof SaveCongressTableParams
     */
    'organizationJob': string;
    /**
     * 
     * @type {string}
     * @memberof SaveCongressTableParams
     */
    'workDepartment': string;
    /**
     * 
     * @type {string}
     * @memberof SaveCongressTableParams
     */
    'workTitle': string;
    /**
     * 
     * @type {string}
     * @memberof SaveCongressTableParams
     */
    'organizationAddress': string;
    /**
     * 
     * @type {string}
     * @memberof SaveCongressTableParams
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof SaveCongressTableParams
     */
    'telephone': string;
    /**
     * 
     * @type {string}
     * @memberof SaveCongressTableParams
     */
    'fax'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SaveCongressTableParams
     */
    'postcode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SaveCongressTableParams
     */
    'phone'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SaveCongressTableParams
     */
    'advice': string;
    /**
     * 
     * @type {string}
     * @memberof SaveCongressTableParams
     */
    'source': string;
}
/**
 * 
 * @export
 * @interface SaveManagerParams
 */
export interface SaveManagerParams {
    /**
     * 
     * @type {string}
     * @memberof SaveManagerParams
     */
    'committeeName': string;
    /**
     * 
     * @type {string}
     * @memberof SaveManagerParams
     */
    'password': string;
}
/**
 * 
 * @export
 * @interface SavePersonalApproveParams
 */
export interface SavePersonalApproveParams {
    /**
     * 
     * @type {number}
     * @memberof SavePersonalApproveParams
     */
    'userId': number;
    /**
     * 
     * @type {string}
     * @memberof SavePersonalApproveParams
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof SavePersonalApproveParams
     */
    'nationality': string;
    /**
     * 
     * @type {string}
     * @memberof SavePersonalApproveParams
     */
    'identificationCardNo': string;
    /**
     * 
     * @type {string}
     * @memberof SavePersonalApproveParams
     */
    'gender'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SavePersonalApproveParams
     */
    'avatarPath'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SavePersonalApproveParams
     */
    'birthDate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SavePersonalApproveParams
     */
    'party': string;
    /**
     * 
     * @type {string}
     * @memberof SavePersonalApproveParams
     */
    'nativePlace'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SavePersonalApproveParams
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof SavePersonalApproveParams
     */
    'organizationFullTime': string;
    /**
     * 
     * @type {string}
     * @memberof SavePersonalApproveParams
     */
    'organizationDepartmentFullTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SavePersonalApproveParams
     */
    'positionFullTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SavePersonalApproveParams
     */
    'levelFullTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SavePersonalApproveParams
     */
    'organizationPartTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SavePersonalApproveParams
     */
    'organizationDepartmentPartTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SavePersonalApproveParams
     */
    'positionPartTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SavePersonalApproveParams
     */
    'levelPartTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SavePersonalApproveParams
     */
    'schoolDomestic': string;
    /**
     * 
     * @type {string}
     * @memberof SavePersonalApproveParams
     */
    'schoolDepartmentDomestic': string;
    /**
     * 
     * @type {string}
     * @memberof SavePersonalApproveParams
     */
    'schoolDateRangeDomestic': string;
    /**
     * 
     * @type {string}
     * @memberof SavePersonalApproveParams
     */
    'graduationDomestic': string;
    /**
     * 
     * @type {string}
     * @memberof SavePersonalApproveParams
     */
    'degreeDomestic': string;
    /**
     * 
     * @type {string}
     * @memberof SavePersonalApproveParams
     */
    'schoolAboard'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SavePersonalApproveParams
     */
    'schoolDepartmentAboard'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SavePersonalApproveParams
     */
    'schoolDateRangeAboard'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SavePersonalApproveParams
     */
    'graduationAboard'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SavePersonalApproveParams
     */
    'degreeAboard'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SavePersonalApproveParams
     */
    'schoolAmateur'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SavePersonalApproveParams
     */
    'schoolDepartmentAmateur'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SavePersonalApproveParams
     */
    'schoolDateRangeAmateur'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SavePersonalApproveParams
     */
    'graduationAmateur'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SavePersonalApproveParams
     */
    'degreeAmateur'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SavePersonalApproveParams
     */
    'organizationUndergo01'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SavePersonalApproveParams
     */
    'positionUndergo01'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SavePersonalApproveParams
     */
    'dateRangeUndergo01'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SavePersonalApproveParams
     */
    'locationUndergo01'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SavePersonalApproveParams
     */
    'organizationUndergo02'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SavePersonalApproveParams
     */
    'positionUndergo02'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SavePersonalApproveParams
     */
    'dateRangeUndergo02'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SavePersonalApproveParams
     */
    'locationUndergo02'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SavePersonalApproveParams
     */
    'organizationUndergo03'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SavePersonalApproveParams
     */
    'positionUndergo03'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SavePersonalApproveParams
     */
    'dateRangeUndergo03'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SavePersonalApproveParams
     */
    'locationUndergo03'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SavePersonalApproveParams
     */
    'organizationAddress01'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SavePersonalApproveParams
     */
    'organizationTel01'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SavePersonalApproveParams
     */
    'organizationPostcode01'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SavePersonalApproveParams
     */
    'organizationAddress02'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SavePersonalApproveParams
     */
    'organizationTel02'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SavePersonalApproveParams
     */
    'organizationPostcode02'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SavePersonalApproveParams
     */
    'massOrganizationPosition'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SavePersonalApproveParams
     */
    'techOrganizationPosition'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SavePersonalApproveParams
     */
    'foreignLanguageLevel'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SavePersonalApproveParams
     */
    'specialty'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SavePersonalApproveParams
     */
    'mainSpecialCommittee': string;
    /**
     * 
     * @type {string}
     * @memberof SavePersonalApproveParams
     */
    'subSpecialCommittee01'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SavePersonalApproveParams
     */
    'subSpecialCommittee02'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SavePersonalApproveParams
     */
    'currentDegree'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SavePersonalApproveParams
     */
    'currentSchool'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SavePersonalApproveParams
     */
    'currentTeacher'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SavePersonalApproveParams
     */
    'studentImagePath'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SavePersonalApproveParams
     */
    'remark'?: string | null;
}
/**
 * 
 * @export
 * @interface SaveSystemConfigParams
 */
export interface SaveSystemConfigParams {
    /**
     * 
     * @type {string}
     * @memberof SaveSystemConfigParams
     */
    'bannerImgPath01'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SaveSystemConfigParams
     */
    'bannerUrl01'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SaveSystemConfigParams
     */
    'bannerImgPath02'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SaveSystemConfigParams
     */
    'bannerUrl02'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SaveSystemConfigParams
     */
    'bannerImgPath03'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SaveSystemConfigParams
     */
    'bannerUrl03'?: string | null;
}
/**
 * 
 * @export
 * @enum {string}
 */

export enum SorterOrder {
    Desc = 'Desc',
    Asc = 'Asc'
}


/**
 * 
 * @export
 * @interface SubmitCongressTableParams
 */
export interface SubmitCongressTableParams {
    /**
     * 
     * @type {string}
     * @memberof SubmitCongressTableParams
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof SubmitCongressTableParams
     */
    'gender': string;
    /**
     * 
     * @type {string}
     * @memberof SubmitCongressTableParams
     */
    'birthDate': string;
    /**
     * 
     * @type {string}
     * @memberof SubmitCongressTableParams
     */
    'job': string;
    /**
     * 
     * @type {string}
     * @memberof SubmitCongressTableParams
     */
    'organizationName': string;
    /**
     * 
     * @type {string}
     * @memberof SubmitCongressTableParams
     */
    'organizationJob': string;
    /**
     * 
     * @type {string}
     * @memberof SubmitCongressTableParams
     */
    'workDepartment': string;
    /**
     * 
     * @type {string}
     * @memberof SubmitCongressTableParams
     */
    'workTitle': string;
    /**
     * 
     * @type {string}
     * @memberof SubmitCongressTableParams
     */
    'organizationAddress': string;
    /**
     * 
     * @type {string}
     * @memberof SubmitCongressTableParams
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof SubmitCongressTableParams
     */
    'telephone': string;
    /**
     * 
     * @type {string}
     * @memberof SubmitCongressTableParams
     */
    'fax'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SubmitCongressTableParams
     */
    'postcode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SubmitCongressTableParams
     */
    'phone'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SubmitCongressTableParams
     */
    'advice': string;
    /**
     * 
     * @type {string}
     * @memberof SubmitCongressTableParams
     */
    'verifyCode': string;
    /**
     * 
     * @type {string}
     * @memberof SubmitCongressTableParams
     */
    'source': string;
}
/**
 * 
 * @export
 * @interface SystemConfig
 */
export interface SystemConfig {
    /**
     * 
     * @type {string}
     * @memberof SystemConfig
     */
    'bannerImgPath01'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SystemConfig
     */
    'bannerUrl01'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SystemConfig
     */
    'bannerImgPath02'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SystemConfig
     */
    'bannerUrl02'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SystemConfig
     */
    'bannerImgPath03'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SystemConfig
     */
    'bannerUrl03'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof SystemConfig
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof SystemConfig
     */
    'createdTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof SystemConfig
     */
    'deletedTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SystemConfig
     */
    'restoredTime'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof SystemConfig
     */
    'isDelete'?: boolean;
}
/**
 * 
 * @export
 * @interface TokenDto
 */
export interface TokenDto {
    /**
     * 
     * @type {string}
     * @memberof TokenDto
     */
    'body'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof TokenDto
     */
    'userId'?: number;
    /**
     * 
     * @type {UserDto}
     * @memberof TokenDto
     */
    'user'?: UserDto;
    /**
     * 
     * @type {string}
     * @memberof TokenDto
     */
    'createdTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof TokenDto
     */
    'expiredTime'?: string;
}
/**
 * 
 * @export
 * @interface UpdateArticleStatusParams
 */
export interface UpdateArticleStatusParams {
    /**
     * 
     * @type {number}
     * @memberof UpdateArticleStatusParams
     */
    'id': number;
    /**
     * 
     * @type {ArticleStatus}
     * @memberof UpdateArticleStatusParams
     */
    'status': ArticleStatus;
}


/**
 * 
 * @export
 * @interface UploadResDto
 */
export interface UploadResDto {
    /**
     * 
     * @type {string}
     * @memberof UploadResDto
     */
    'url'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UploadResDto
     */
    'path'?: string | null;
}
/**
 * 
 * @export
 * @interface UserDto
 */
export interface UserDto {
    /**
     * 
     * @type {number}
     * @memberof UserDto
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof UserDto
     */
    'createdTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserDto
     */
    'deletedTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserDto
     */
    'restoredTime'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UserDto
     */
    'isDelete'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UserDto
     */
    'telephone'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UserDto
     */
    'isSu'?: boolean;
    /**
     * 
     * @type {PersonalApprove}
     * @memberof UserDto
     */
    'personalApprove'?: PersonalApprove;
    /**
     * 
     * @type {string}
     * @memberof UserDto
     */
    'registeredTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserDto
     */
    'memberExpiredTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserDto
     */
    'memberNo'?: string | null;
    /**
     * 
     * @type {MemberLevel}
     * @memberof UserDto
     */
    'memberLevel'?: MemberLevel;
    /**
     * 
     * @type {boolean}
     * @memberof UserDto
     */
    'isManager'?: boolean;
}


/**
 * 
 * @export
 * @interface UserDtoSearchResponseDto
 */
export interface UserDtoSearchResponseDto {
    /**
     * 
     * @type {Array<UserDto>}
     * @memberof UserDtoSearchResponseDto
     */
    'list'?: Array<UserDto> | null;
    /**
     * 
     * @type {number}
     * @memberof UserDtoSearchResponseDto
     */
    'total'?: number;
}
/**
 * 
 * @export
 * @interface WeatherForecast
 */
export interface WeatherForecast {
    /**
     * 
     * @type {string}
     * @memberof WeatherForecast
     */
    'date'?: string;
    /**
     * 
     * @type {number}
     * @memberof WeatherForecast
     */
    'temperatureC'?: number;
    /**
     * 
     * @type {number}
     * @memberof WeatherForecast
     */
    'temperatureF'?: number;
    /**
     * 
     * @type {string}
     * @memberof WeatherForecast
     */
    'summary'?: string | null;
}

/**
 * ArticleApi - axios parameter creator
 * @export
 */
export const ArticleApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {CopyArticleParams} [copyArticleParams] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleCopyPost: async (copyArticleParams?: CopyArticleParams, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Article/Copy`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(copyArticleParams, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {FindParams} [findParams] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleDeletePost: async (findParams?: FindParams, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Article/Delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(findParams, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleFindGet: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('articleFindGet', 'id', id)
            const localVarPath = `/Article/Find`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (id !== undefined) {
                localVarQueryParameter['Id'] = id;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SaveArticleParams} [saveArticleParams] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleSavePost: async (saveArticleParams?: SaveArticleParams, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Article/Save`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(saveArticleParams, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} pi 
         * @param {number} ps 
         * @param {string} [catalogs] 
         * @param {string} [keywords] 
         * @param {boolean} [includeHidden] 
         * @param {string} [sorterKey] 
         * @param {boolean} [includeDeleted] 
         * @param {SorterOrder} [sorterOrder] 
         * @param {boolean} [isDelete] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleSearchGet: async (pi: number, ps: number, catalogs?: string, keywords?: string, includeHidden?: boolean, sorterKey?: string, includeDeleted?: boolean, sorterOrder?: SorterOrder, isDelete?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pi' is not null or undefined
            assertParamExists('articleSearchGet', 'pi', pi)
            // verify required parameter 'ps' is not null or undefined
            assertParamExists('articleSearchGet', 'ps', ps)
            const localVarPath = `/Article/Search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (catalogs !== undefined) {
                localVarQueryParameter['Catalogs'] = catalogs;
            }

            if (keywords !== undefined) {
                localVarQueryParameter['Keywords'] = keywords;
            }

            if (includeHidden !== undefined) {
                localVarQueryParameter['IncludeHidden'] = includeHidden;
            }

            if (pi !== undefined) {
                localVarQueryParameter['Pi'] = pi;
            }

            if (ps !== undefined) {
                localVarQueryParameter['Ps'] = ps;
            }

            if (sorterKey !== undefined) {
                localVarQueryParameter['SorterKey'] = sorterKey;
            }

            if (includeDeleted !== undefined) {
                localVarQueryParameter['IncludeDeleted'] = includeDeleted;
            }

            if (sorterOrder !== undefined) {
                localVarQueryParameter['SorterOrder'] = sorterOrder;
            }

            if (isDelete !== undefined) {
                localVarQueryParameter['IsDelete'] = isDelete;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpdateArticleStatusParams} [updateArticleStatusParams] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUpdateStatusPost: async (updateArticleStatusParams?: UpdateArticleStatusParams, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Article/UpdateStatus`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateArticleStatusParams, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [contentType] 
         * @param {string} [contentDisposition] 
         * @param {{ [key: string]: Array<string>; }} [headers] 
         * @param {number} [length] 
         * @param {string} [name] 
         * @param {string} [fileName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUploadFilePost: async (contentType?: string, contentDisposition?: string, headers?: { [key: string]: Array<string>; }, length?: number, name?: string, fileName?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Article/UploadFile`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();


            if (contentType !== undefined) { 
                localVarFormParams.append('ContentType', contentType as any);
            }
    
            if (contentDisposition !== undefined) { 
                localVarFormParams.append('ContentDisposition', contentDisposition as any);
            }
    
            if (headers !== undefined) { 
                localVarFormParams.append('Headers', new Blob([JSON.stringify(headers)], { type: "application/json", }));
            }
    
            if (length !== undefined) { 
                localVarFormParams.append('Length', length as any);
            }
    
            if (name !== undefined) { 
                localVarFormParams.append('Name', name as any);
            }
    
            if (fileName !== undefined) { 
                localVarFormParams.append('FileName', fileName as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [contentType] 
         * @param {string} [contentDisposition] 
         * @param {{ [key: string]: Array<string>; }} [headers] 
         * @param {number} [length] 
         * @param {string} [name] 
         * @param {string} [fileName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUploadImagePost: async (contentType?: string, contentDisposition?: string, headers?: { [key: string]: Array<string>; }, length?: number, name?: string, fileName?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Article/UploadImage`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();


            if (contentType !== undefined) { 
                localVarFormParams.append('ContentType', contentType as any);
            }
    
            if (contentDisposition !== undefined) { 
                localVarFormParams.append('ContentDisposition', contentDisposition as any);
            }
    
            if (headers !== undefined) { 
                localVarFormParams.append('Headers', new Blob([JSON.stringify(headers)], { type: "application/json", }));
            }
    
            if (length !== undefined) { 
                localVarFormParams.append('Length', length as any);
            }
    
            if (name !== undefined) { 
                localVarFormParams.append('Name', name as any);
            }
    
            if (fileName !== undefined) { 
                localVarFormParams.append('FileName', fileName as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ArticleApi - functional programming interface
 * @export
 */
export const ArticleApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ArticleApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {CopyArticleParams} [copyArticleParams] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async articleCopyPost(copyArticleParams?: CopyArticleParams, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ArticleDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.articleCopyPost(copyArticleParams, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ArticleApi.articleCopyPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {FindParams} [findParams] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async articleDeletePost(findParams?: FindParams, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.articleDeletePost(findParams, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ArticleApi.articleDeletePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async articleFindGet(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ArticleDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.articleFindGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ArticleApi.articleFindGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {SaveArticleParams} [saveArticleParams] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async articleSavePost(saveArticleParams?: SaveArticleParams, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ArticleDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.articleSavePost(saveArticleParams, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ArticleApi.articleSavePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} pi 
         * @param {number} ps 
         * @param {string} [catalogs] 
         * @param {string} [keywords] 
         * @param {boolean} [includeHidden] 
         * @param {string} [sorterKey] 
         * @param {boolean} [includeDeleted] 
         * @param {SorterOrder} [sorterOrder] 
         * @param {boolean} [isDelete] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async articleSearchGet(pi: number, ps: number, catalogs?: string, keywords?: string, includeHidden?: boolean, sorterKey?: string, includeDeleted?: boolean, sorterOrder?: SorterOrder, isDelete?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ArticleDtoSearchResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.articleSearchGet(pi, ps, catalogs, keywords, includeHidden, sorterKey, includeDeleted, sorterOrder, isDelete, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ArticleApi.articleSearchGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {UpdateArticleStatusParams} [updateArticleStatusParams] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async articleUpdateStatusPost(updateArticleStatusParams?: UpdateArticleStatusParams, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ArticleDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.articleUpdateStatusPost(updateArticleStatusParams, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ArticleApi.articleUpdateStatusPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [contentType] 
         * @param {string} [contentDisposition] 
         * @param {{ [key: string]: Array<string>; }} [headers] 
         * @param {number} [length] 
         * @param {string} [name] 
         * @param {string} [fileName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async articleUploadFilePost(contentType?: string, contentDisposition?: string, headers?: { [key: string]: Array<string>; }, length?: number, name?: string, fileName?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UploadResDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.articleUploadFilePost(contentType, contentDisposition, headers, length, name, fileName, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ArticleApi.articleUploadFilePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [contentType] 
         * @param {string} [contentDisposition] 
         * @param {{ [key: string]: Array<string>; }} [headers] 
         * @param {number} [length] 
         * @param {string} [name] 
         * @param {string} [fileName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async articleUploadImagePost(contentType?: string, contentDisposition?: string, headers?: { [key: string]: Array<string>; }, length?: number, name?: string, fileName?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UploadResDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.articleUploadImagePost(contentType, contentDisposition, headers, length, name, fileName, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ArticleApi.articleUploadImagePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ArticleApi - factory interface
 * @export
 */
export const ArticleApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ArticleApiFp(configuration)
    return {
        /**
         * 
         * @param {ArticleApiArticleCopyPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleCopyPost(requestParameters: ArticleApiArticleCopyPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ArticleDto> {
            return localVarFp.articleCopyPost(requestParameters.copyArticleParams, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ArticleApiArticleDeletePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleDeletePost(requestParameters: ArticleApiArticleDeletePostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.articleDeletePost(requestParameters.findParams, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ArticleApiArticleFindGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleFindGet(requestParameters: ArticleApiArticleFindGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ArticleDto> {
            return localVarFp.articleFindGet(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ArticleApiArticleSavePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleSavePost(requestParameters: ArticleApiArticleSavePostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ArticleDto> {
            return localVarFp.articleSavePost(requestParameters.saveArticleParams, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ArticleApiArticleSearchGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleSearchGet(requestParameters: ArticleApiArticleSearchGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ArticleDtoSearchResponseDto> {
            return localVarFp.articleSearchGet(requestParameters.pi, requestParameters.ps, requestParameters.catalogs, requestParameters.keywords, requestParameters.includeHidden, requestParameters.sorterKey, requestParameters.includeDeleted, requestParameters.sorterOrder, requestParameters.isDelete, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ArticleApiArticleUpdateStatusPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUpdateStatusPost(requestParameters: ArticleApiArticleUpdateStatusPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ArticleDto> {
            return localVarFp.articleUpdateStatusPost(requestParameters.updateArticleStatusParams, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ArticleApiArticleUploadFilePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUploadFilePost(requestParameters: ArticleApiArticleUploadFilePostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<UploadResDto> {
            return localVarFp.articleUploadFilePost(requestParameters.contentType, requestParameters.contentDisposition, requestParameters.headers, requestParameters.length, requestParameters.name, requestParameters.fileName, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ArticleApiArticleUploadImagePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUploadImagePost(requestParameters: ArticleApiArticleUploadImagePostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<UploadResDto> {
            return localVarFp.articleUploadImagePost(requestParameters.contentType, requestParameters.contentDisposition, requestParameters.headers, requestParameters.length, requestParameters.name, requestParameters.fileName, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for articleCopyPost operation in ArticleApi.
 * @export
 * @interface ArticleApiArticleCopyPostRequest
 */
export interface ArticleApiArticleCopyPostRequest {
    /**
     * 
     * @type {CopyArticleParams}
     * @memberof ArticleApiArticleCopyPost
     */
    readonly copyArticleParams?: CopyArticleParams
}

/**
 * Request parameters for articleDeletePost operation in ArticleApi.
 * @export
 * @interface ArticleApiArticleDeletePostRequest
 */
export interface ArticleApiArticleDeletePostRequest {
    /**
     * 
     * @type {FindParams}
     * @memberof ArticleApiArticleDeletePost
     */
    readonly findParams?: FindParams
}

/**
 * Request parameters for articleFindGet operation in ArticleApi.
 * @export
 * @interface ArticleApiArticleFindGetRequest
 */
export interface ArticleApiArticleFindGetRequest {
    /**
     * 
     * @type {number}
     * @memberof ArticleApiArticleFindGet
     */
    readonly id: number
}

/**
 * Request parameters for articleSavePost operation in ArticleApi.
 * @export
 * @interface ArticleApiArticleSavePostRequest
 */
export interface ArticleApiArticleSavePostRequest {
    /**
     * 
     * @type {SaveArticleParams}
     * @memberof ArticleApiArticleSavePost
     */
    readonly saveArticleParams?: SaveArticleParams
}

/**
 * Request parameters for articleSearchGet operation in ArticleApi.
 * @export
 * @interface ArticleApiArticleSearchGetRequest
 */
export interface ArticleApiArticleSearchGetRequest {
    /**
     * 
     * @type {number}
     * @memberof ArticleApiArticleSearchGet
     */
    readonly pi: number

    /**
     * 
     * @type {number}
     * @memberof ArticleApiArticleSearchGet
     */
    readonly ps: number

    /**
     * 
     * @type {string}
     * @memberof ArticleApiArticleSearchGet
     */
    readonly catalogs?: string

    /**
     * 
     * @type {string}
     * @memberof ArticleApiArticleSearchGet
     */
    readonly keywords?: string

    /**
     * 
     * @type {boolean}
     * @memberof ArticleApiArticleSearchGet
     */
    readonly includeHidden?: boolean

    /**
     * 
     * @type {string}
     * @memberof ArticleApiArticleSearchGet
     */
    readonly sorterKey?: string

    /**
     * 
     * @type {boolean}
     * @memberof ArticleApiArticleSearchGet
     */
    readonly includeDeleted?: boolean

    /**
     * 
     * @type {SorterOrder}
     * @memberof ArticleApiArticleSearchGet
     */
    readonly sorterOrder?: SorterOrder

    /**
     * 
     * @type {boolean}
     * @memberof ArticleApiArticleSearchGet
     */
    readonly isDelete?: boolean
}

/**
 * Request parameters for articleUpdateStatusPost operation in ArticleApi.
 * @export
 * @interface ArticleApiArticleUpdateStatusPostRequest
 */
export interface ArticleApiArticleUpdateStatusPostRequest {
    /**
     * 
     * @type {UpdateArticleStatusParams}
     * @memberof ArticleApiArticleUpdateStatusPost
     */
    readonly updateArticleStatusParams?: UpdateArticleStatusParams
}

/**
 * Request parameters for articleUploadFilePost operation in ArticleApi.
 * @export
 * @interface ArticleApiArticleUploadFilePostRequest
 */
export interface ArticleApiArticleUploadFilePostRequest {
    /**
     * 
     * @type {string}
     * @memberof ArticleApiArticleUploadFilePost
     */
    readonly contentType?: string

    /**
     * 
     * @type {string}
     * @memberof ArticleApiArticleUploadFilePost
     */
    readonly contentDisposition?: string

    /**
     * 
     * @type {{ [key: string]: Array<string>; }}
     * @memberof ArticleApiArticleUploadFilePost
     */
    readonly headers?: { [key: string]: Array<string>; }

    /**
     * 
     * @type {number}
     * @memberof ArticleApiArticleUploadFilePost
     */
    readonly length?: number

    /**
     * 
     * @type {string}
     * @memberof ArticleApiArticleUploadFilePost
     */
    readonly name?: string

    /**
     * 
     * @type {string}
     * @memberof ArticleApiArticleUploadFilePost
     */
    readonly fileName?: string
}

/**
 * Request parameters for articleUploadImagePost operation in ArticleApi.
 * @export
 * @interface ArticleApiArticleUploadImagePostRequest
 */
export interface ArticleApiArticleUploadImagePostRequest {
    /**
     * 
     * @type {string}
     * @memberof ArticleApiArticleUploadImagePost
     */
    readonly contentType?: string

    /**
     * 
     * @type {string}
     * @memberof ArticleApiArticleUploadImagePost
     */
    readonly contentDisposition?: string

    /**
     * 
     * @type {{ [key: string]: Array<string>; }}
     * @memberof ArticleApiArticleUploadImagePost
     */
    readonly headers?: { [key: string]: Array<string>; }

    /**
     * 
     * @type {number}
     * @memberof ArticleApiArticleUploadImagePost
     */
    readonly length?: number

    /**
     * 
     * @type {string}
     * @memberof ArticleApiArticleUploadImagePost
     */
    readonly name?: string

    /**
     * 
     * @type {string}
     * @memberof ArticleApiArticleUploadImagePost
     */
    readonly fileName?: string
}

/**
 * ArticleApi - object-oriented interface
 * @export
 * @class ArticleApi
 * @extends {BaseAPI}
 */
export class ArticleApi extends BaseAPI {
    /**
     * 
     * @param {ArticleApiArticleCopyPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ArticleApi
     */
    public articleCopyPost(requestParameters: ArticleApiArticleCopyPostRequest = {}, options?: RawAxiosRequestConfig) {
        return ArticleApiFp(this.configuration).articleCopyPost(requestParameters.copyArticleParams, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ArticleApiArticleDeletePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ArticleApi
     */
    public articleDeletePost(requestParameters: ArticleApiArticleDeletePostRequest = {}, options?: RawAxiosRequestConfig) {
        return ArticleApiFp(this.configuration).articleDeletePost(requestParameters.findParams, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ArticleApiArticleFindGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ArticleApi
     */
    public articleFindGet(requestParameters: ArticleApiArticleFindGetRequest, options?: RawAxiosRequestConfig) {
        return ArticleApiFp(this.configuration).articleFindGet(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ArticleApiArticleSavePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ArticleApi
     */
    public articleSavePost(requestParameters: ArticleApiArticleSavePostRequest = {}, options?: RawAxiosRequestConfig) {
        return ArticleApiFp(this.configuration).articleSavePost(requestParameters.saveArticleParams, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ArticleApiArticleSearchGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ArticleApi
     */
    public articleSearchGet(requestParameters: ArticleApiArticleSearchGetRequest, options?: RawAxiosRequestConfig) {
        return ArticleApiFp(this.configuration).articleSearchGet(requestParameters.pi, requestParameters.ps, requestParameters.catalogs, requestParameters.keywords, requestParameters.includeHidden, requestParameters.sorterKey, requestParameters.includeDeleted, requestParameters.sorterOrder, requestParameters.isDelete, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ArticleApiArticleUpdateStatusPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ArticleApi
     */
    public articleUpdateStatusPost(requestParameters: ArticleApiArticleUpdateStatusPostRequest = {}, options?: RawAxiosRequestConfig) {
        return ArticleApiFp(this.configuration).articleUpdateStatusPost(requestParameters.updateArticleStatusParams, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ArticleApiArticleUploadFilePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ArticleApi
     */
    public articleUploadFilePost(requestParameters: ArticleApiArticleUploadFilePostRequest = {}, options?: RawAxiosRequestConfig) {
        return ArticleApiFp(this.configuration).articleUploadFilePost(requestParameters.contentType, requestParameters.contentDisposition, requestParameters.headers, requestParameters.length, requestParameters.name, requestParameters.fileName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ArticleApiArticleUploadImagePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ArticleApi
     */
    public articleUploadImagePost(requestParameters: ArticleApiArticleUploadImagePostRequest = {}, options?: RawAxiosRequestConfig) {
        return ArticleApiFp(this.configuration).articleUploadImagePost(requestParameters.contentType, requestParameters.contentDisposition, requestParameters.headers, requestParameters.length, requestParameters.name, requestParameters.fileName, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AuthorizeApi - axios parameter creator
 * @export
 */
export const AuthorizeApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} token 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authorizeCheckGet: async (token: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'token' is not null or undefined
            assertParamExists('authorizeCheckGet', 'token', token)
            const localVarPath = `/Authorize/Check`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (token !== undefined) {
                localVarQueryParameter['Token'] = token;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {AuthorizeLoginByTelParams} [authorizeLoginByTelParams] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authorizeLoginByTelPost: async (authorizeLoginByTelParams?: AuthorizeLoginByTelParams, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Authorize/LoginByTel`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(authorizeLoginByTelParams, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {AuthorizeLoginParams} [authorizeLoginParams] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authorizeLoginPost: async (authorizeLoginParams?: AuthorizeLoginParams, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Authorize/Login`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(authorizeLoginParams, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AuthorizeApi - functional programming interface
 * @export
 */
export const AuthorizeApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AuthorizeApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} token 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authorizeCheckGet(token: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authorizeCheckGet(token, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthorizeApi.authorizeCheckGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {AuthorizeLoginByTelParams} [authorizeLoginByTelParams] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authorizeLoginByTelPost(authorizeLoginByTelParams?: AuthorizeLoginByTelParams, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TokenDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authorizeLoginByTelPost(authorizeLoginByTelParams, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthorizeApi.authorizeLoginByTelPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {AuthorizeLoginParams} [authorizeLoginParams] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authorizeLoginPost(authorizeLoginParams?: AuthorizeLoginParams, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TokenDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authorizeLoginPost(authorizeLoginParams, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthorizeApi.authorizeLoginPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AuthorizeApi - factory interface
 * @export
 */
export const AuthorizeApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AuthorizeApiFp(configuration)
    return {
        /**
         * 
         * @param {AuthorizeApiAuthorizeCheckGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authorizeCheckGet(requestParameters: AuthorizeApiAuthorizeCheckGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<UserDto> {
            return localVarFp.authorizeCheckGet(requestParameters.token, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AuthorizeApiAuthorizeLoginByTelPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authorizeLoginByTelPost(requestParameters: AuthorizeApiAuthorizeLoginByTelPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<TokenDto> {
            return localVarFp.authorizeLoginByTelPost(requestParameters.authorizeLoginByTelParams, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AuthorizeApiAuthorizeLoginPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authorizeLoginPost(requestParameters: AuthorizeApiAuthorizeLoginPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<TokenDto> {
            return localVarFp.authorizeLoginPost(requestParameters.authorizeLoginParams, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for authorizeCheckGet operation in AuthorizeApi.
 * @export
 * @interface AuthorizeApiAuthorizeCheckGetRequest
 */
export interface AuthorizeApiAuthorizeCheckGetRequest {
    /**
     * 
     * @type {string}
     * @memberof AuthorizeApiAuthorizeCheckGet
     */
    readonly token: string
}

/**
 * Request parameters for authorizeLoginByTelPost operation in AuthorizeApi.
 * @export
 * @interface AuthorizeApiAuthorizeLoginByTelPostRequest
 */
export interface AuthorizeApiAuthorizeLoginByTelPostRequest {
    /**
     * 
     * @type {AuthorizeLoginByTelParams}
     * @memberof AuthorizeApiAuthorizeLoginByTelPost
     */
    readonly authorizeLoginByTelParams?: AuthorizeLoginByTelParams
}

/**
 * Request parameters for authorizeLoginPost operation in AuthorizeApi.
 * @export
 * @interface AuthorizeApiAuthorizeLoginPostRequest
 */
export interface AuthorizeApiAuthorizeLoginPostRequest {
    /**
     * 
     * @type {AuthorizeLoginParams}
     * @memberof AuthorizeApiAuthorizeLoginPost
     */
    readonly authorizeLoginParams?: AuthorizeLoginParams
}

/**
 * AuthorizeApi - object-oriented interface
 * @export
 * @class AuthorizeApi
 * @extends {BaseAPI}
 */
export class AuthorizeApi extends BaseAPI {
    /**
     * 
     * @param {AuthorizeApiAuthorizeCheckGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthorizeApi
     */
    public authorizeCheckGet(requestParameters: AuthorizeApiAuthorizeCheckGetRequest, options?: RawAxiosRequestConfig) {
        return AuthorizeApiFp(this.configuration).authorizeCheckGet(requestParameters.token, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AuthorizeApiAuthorizeLoginByTelPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthorizeApi
     */
    public authorizeLoginByTelPost(requestParameters: AuthorizeApiAuthorizeLoginByTelPostRequest = {}, options?: RawAxiosRequestConfig) {
        return AuthorizeApiFp(this.configuration).authorizeLoginByTelPost(requestParameters.authorizeLoginByTelParams, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AuthorizeApiAuthorizeLoginPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthorizeApi
     */
    public authorizeLoginPost(requestParameters: AuthorizeApiAuthorizeLoginPostRequest = {}, options?: RawAxiosRequestConfig) {
        return AuthorizeApiFp(this.configuration).authorizeLoginPost(requestParameters.authorizeLoginParams, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CongressTableApi - axios parameter creator
 * @export
 */
export const CongressTableApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {FindParams} [findParams] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        congressTableDeletePost: async (findParams?: FindParams, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/CongressTable/Delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(findParams, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        congressTableFindGet: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('congressTableFindGet', 'id', id)
            const localVarPath = `/CongressTable/Find`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (id !== undefined) {
                localVarQueryParameter['Id'] = id;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SaveCongressTableParams} [saveCongressTableParams] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        congressTableSavePost: async (saveCongressTableParams?: SaveCongressTableParams, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/CongressTable/Save`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(saveCongressTableParams, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} pi 
         * @param {number} ps 
         * @param {string} [keywords] 
         * @param {string} [sorterKey] 
         * @param {boolean} [includeDeleted] 
         * @param {SorterOrder} [sorterOrder] 
         * @param {boolean} [isDelete] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        congressTableSearchGet: async (pi: number, ps: number, keywords?: string, sorterKey?: string, includeDeleted?: boolean, sorterOrder?: SorterOrder, isDelete?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pi' is not null or undefined
            assertParamExists('congressTableSearchGet', 'pi', pi)
            // verify required parameter 'ps' is not null or undefined
            assertParamExists('congressTableSearchGet', 'ps', ps)
            const localVarPath = `/CongressTable/Search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (keywords !== undefined) {
                localVarQueryParameter['Keywords'] = keywords;
            }

            if (pi !== undefined) {
                localVarQueryParameter['Pi'] = pi;
            }

            if (ps !== undefined) {
                localVarQueryParameter['Ps'] = ps;
            }

            if (sorterKey !== undefined) {
                localVarQueryParameter['SorterKey'] = sorterKey;
            }

            if (includeDeleted !== undefined) {
                localVarQueryParameter['IncludeDeleted'] = includeDeleted;
            }

            if (sorterOrder !== undefined) {
                localVarQueryParameter['SorterOrder'] = sorterOrder;
            }

            if (isDelete !== undefined) {
                localVarQueryParameter['IsDelete'] = isDelete;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SubmitCongressTableParams} [submitCongressTableParams] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        congressTableSubmitPost: async (submitCongressTableParams?: SubmitCongressTableParams, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/CongressTable/Submit`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(submitCongressTableParams, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CongressTableApi - functional programming interface
 * @export
 */
export const CongressTableApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CongressTableApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {FindParams} [findParams] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async congressTableDeletePost(findParams?: FindParams, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.congressTableDeletePost(findParams, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CongressTableApi.congressTableDeletePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async congressTableFindGet(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ArticleDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.congressTableFindGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CongressTableApi.congressTableFindGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {SaveCongressTableParams} [saveCongressTableParams] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async congressTableSavePost(saveCongressTableParams?: SaveCongressTableParams, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CongressTable>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.congressTableSavePost(saveCongressTableParams, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CongressTableApi.congressTableSavePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} pi 
         * @param {number} ps 
         * @param {string} [keywords] 
         * @param {string} [sorterKey] 
         * @param {boolean} [includeDeleted] 
         * @param {SorterOrder} [sorterOrder] 
         * @param {boolean} [isDelete] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async congressTableSearchGet(pi: number, ps: number, keywords?: string, sorterKey?: string, includeDeleted?: boolean, sorterOrder?: SorterOrder, isDelete?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CongressTableSearchResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.congressTableSearchGet(pi, ps, keywords, sorterKey, includeDeleted, sorterOrder, isDelete, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CongressTableApi.congressTableSearchGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {SubmitCongressTableParams} [submitCongressTableParams] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async congressTableSubmitPost(submitCongressTableParams?: SubmitCongressTableParams, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CongressTable>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.congressTableSubmitPost(submitCongressTableParams, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CongressTableApi.congressTableSubmitPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CongressTableApi - factory interface
 * @export
 */
export const CongressTableApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CongressTableApiFp(configuration)
    return {
        /**
         * 
         * @param {CongressTableApiCongressTableDeletePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        congressTableDeletePost(requestParameters: CongressTableApiCongressTableDeletePostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.congressTableDeletePost(requestParameters.findParams, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CongressTableApiCongressTableFindGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        congressTableFindGet(requestParameters: CongressTableApiCongressTableFindGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ArticleDto> {
            return localVarFp.congressTableFindGet(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CongressTableApiCongressTableSavePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        congressTableSavePost(requestParameters: CongressTableApiCongressTableSavePostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<CongressTable> {
            return localVarFp.congressTableSavePost(requestParameters.saveCongressTableParams, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CongressTableApiCongressTableSearchGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        congressTableSearchGet(requestParameters: CongressTableApiCongressTableSearchGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<CongressTableSearchResponse> {
            return localVarFp.congressTableSearchGet(requestParameters.pi, requestParameters.ps, requestParameters.keywords, requestParameters.sorterKey, requestParameters.includeDeleted, requestParameters.sorterOrder, requestParameters.isDelete, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CongressTableApiCongressTableSubmitPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        congressTableSubmitPost(requestParameters: CongressTableApiCongressTableSubmitPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<CongressTable> {
            return localVarFp.congressTableSubmitPost(requestParameters.submitCongressTableParams, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for congressTableDeletePost operation in CongressTableApi.
 * @export
 * @interface CongressTableApiCongressTableDeletePostRequest
 */
export interface CongressTableApiCongressTableDeletePostRequest {
    /**
     * 
     * @type {FindParams}
     * @memberof CongressTableApiCongressTableDeletePost
     */
    readonly findParams?: FindParams
}

/**
 * Request parameters for congressTableFindGet operation in CongressTableApi.
 * @export
 * @interface CongressTableApiCongressTableFindGetRequest
 */
export interface CongressTableApiCongressTableFindGetRequest {
    /**
     * 
     * @type {number}
     * @memberof CongressTableApiCongressTableFindGet
     */
    readonly id: number
}

/**
 * Request parameters for congressTableSavePost operation in CongressTableApi.
 * @export
 * @interface CongressTableApiCongressTableSavePostRequest
 */
export interface CongressTableApiCongressTableSavePostRequest {
    /**
     * 
     * @type {SaveCongressTableParams}
     * @memberof CongressTableApiCongressTableSavePost
     */
    readonly saveCongressTableParams?: SaveCongressTableParams
}

/**
 * Request parameters for congressTableSearchGet operation in CongressTableApi.
 * @export
 * @interface CongressTableApiCongressTableSearchGetRequest
 */
export interface CongressTableApiCongressTableSearchGetRequest {
    /**
     * 
     * @type {number}
     * @memberof CongressTableApiCongressTableSearchGet
     */
    readonly pi: number

    /**
     * 
     * @type {number}
     * @memberof CongressTableApiCongressTableSearchGet
     */
    readonly ps: number

    /**
     * 
     * @type {string}
     * @memberof CongressTableApiCongressTableSearchGet
     */
    readonly keywords?: string

    /**
     * 
     * @type {string}
     * @memberof CongressTableApiCongressTableSearchGet
     */
    readonly sorterKey?: string

    /**
     * 
     * @type {boolean}
     * @memberof CongressTableApiCongressTableSearchGet
     */
    readonly includeDeleted?: boolean

    /**
     * 
     * @type {SorterOrder}
     * @memberof CongressTableApiCongressTableSearchGet
     */
    readonly sorterOrder?: SorterOrder

    /**
     * 
     * @type {boolean}
     * @memberof CongressTableApiCongressTableSearchGet
     */
    readonly isDelete?: boolean
}

/**
 * Request parameters for congressTableSubmitPost operation in CongressTableApi.
 * @export
 * @interface CongressTableApiCongressTableSubmitPostRequest
 */
export interface CongressTableApiCongressTableSubmitPostRequest {
    /**
     * 
     * @type {SubmitCongressTableParams}
     * @memberof CongressTableApiCongressTableSubmitPost
     */
    readonly submitCongressTableParams?: SubmitCongressTableParams
}

/**
 * CongressTableApi - object-oriented interface
 * @export
 * @class CongressTableApi
 * @extends {BaseAPI}
 */
export class CongressTableApi extends BaseAPI {
    /**
     * 
     * @param {CongressTableApiCongressTableDeletePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CongressTableApi
     */
    public congressTableDeletePost(requestParameters: CongressTableApiCongressTableDeletePostRequest = {}, options?: RawAxiosRequestConfig) {
        return CongressTableApiFp(this.configuration).congressTableDeletePost(requestParameters.findParams, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CongressTableApiCongressTableFindGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CongressTableApi
     */
    public congressTableFindGet(requestParameters: CongressTableApiCongressTableFindGetRequest, options?: RawAxiosRequestConfig) {
        return CongressTableApiFp(this.configuration).congressTableFindGet(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CongressTableApiCongressTableSavePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CongressTableApi
     */
    public congressTableSavePost(requestParameters: CongressTableApiCongressTableSavePostRequest = {}, options?: RawAxiosRequestConfig) {
        return CongressTableApiFp(this.configuration).congressTableSavePost(requestParameters.saveCongressTableParams, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CongressTableApiCongressTableSearchGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CongressTableApi
     */
    public congressTableSearchGet(requestParameters: CongressTableApiCongressTableSearchGetRequest, options?: RawAxiosRequestConfig) {
        return CongressTableApiFp(this.configuration).congressTableSearchGet(requestParameters.pi, requestParameters.ps, requestParameters.keywords, requestParameters.sorterKey, requestParameters.includeDeleted, requestParameters.sorterOrder, requestParameters.isDelete, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CongressTableApiCongressTableSubmitPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CongressTableApi
     */
    public congressTableSubmitPost(requestParameters: CongressTableApiCongressTableSubmitPostRequest = {}, options?: RawAxiosRequestConfig) {
        return CongressTableApiFp(this.configuration).congressTableSubmitPost(requestParameters.submitCongressTableParams, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * DoubleMemberApi - axios parameter creator
 * @export
 */
export const DoubleMemberApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {BatchImportDoubleMemberModel} [batchImportDoubleMemberModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        doubleMemberBatchImportRecordPost: async (batchImportDoubleMemberModel?: BatchImportDoubleMemberModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/DoubleMember/BatchImportRecord`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(batchImportDoubleMemberModel, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} telephoneEmail 
         * @param {string} name 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        doubleMemberCheckRecordGet: async (telephoneEmail: string, name: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'telephoneEmail' is not null or undefined
            assertParamExists('doubleMemberCheckRecordGet', 'telephoneEmail', telephoneEmail)
            // verify required parameter 'name' is not null or undefined
            assertParamExists('doubleMemberCheckRecordGet', 'name', name)
            const localVarPath = `/DoubleMember/CheckRecord`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (telephoneEmail !== undefined) {
                localVarQueryParameter['TelephoneEmail'] = telephoneEmail;
            }

            if (name !== undefined) {
                localVarQueryParameter['Name'] = name;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [fromDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        doubleMemberExportDoubleMemberPaymentGet: async (fromDate?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/DoubleMember/ExportDoubleMemberPayment`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (fromDate !== undefined) {
                localVarQueryParameter['FromDate'] = (fromDate as any instanceof Date) ?
                    (fromDate as any).toISOString() :
                    fromDate;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        doubleMemberListAllRecordGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/DoubleMember/ListAllRecord`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {DoubleMemberRegisterModel} [doubleMemberRegisterModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        doubleMemberRegisterPost: async (doubleMemberRegisterModel?: DoubleMemberRegisterModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/DoubleMember/Register`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(doubleMemberRegisterModel, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {FindParams} [findParams] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        doubleMemberSendSMSPost: async (findParams?: FindParams, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/DoubleMember/SendSMS`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(findParams, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DoubleMemberApi - functional programming interface
 * @export
 */
export const DoubleMemberApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DoubleMemberApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {BatchImportDoubleMemberModel} [batchImportDoubleMemberModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async doubleMemberBatchImportRecordPost(batchImportDoubleMemberModel?: BatchImportDoubleMemberModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.doubleMemberBatchImportRecordPost(batchImportDoubleMemberModel, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DoubleMemberApi.doubleMemberBatchImportRecordPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} telephoneEmail 
         * @param {string} name 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async doubleMemberCheckRecordGet(telephoneEmail: string, name: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DoubleMemberImportRecordDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.doubleMemberCheckRecordGet(telephoneEmail, name, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DoubleMemberApi.doubleMemberCheckRecordGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [fromDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async doubleMemberExportDoubleMemberPaymentGet(fromDate?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PaymentDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.doubleMemberExportDoubleMemberPaymentGet(fromDate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DoubleMemberApi.doubleMemberExportDoubleMemberPaymentGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async doubleMemberListAllRecordGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DoubleMemberImportRecordDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.doubleMemberListAllRecordGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DoubleMemberApi.doubleMemberListAllRecordGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {DoubleMemberRegisterModel} [doubleMemberRegisterModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async doubleMemberRegisterPost(doubleMemberRegisterModel?: DoubleMemberRegisterModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.doubleMemberRegisterPost(doubleMemberRegisterModel, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DoubleMemberApi.doubleMemberRegisterPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {FindParams} [findParams] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async doubleMemberSendSMSPost(findParams?: FindParams, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.doubleMemberSendSMSPost(findParams, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DoubleMemberApi.doubleMemberSendSMSPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DoubleMemberApi - factory interface
 * @export
 */
export const DoubleMemberApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DoubleMemberApiFp(configuration)
    return {
        /**
         * 
         * @param {DoubleMemberApiDoubleMemberBatchImportRecordPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        doubleMemberBatchImportRecordPost(requestParameters: DoubleMemberApiDoubleMemberBatchImportRecordPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.doubleMemberBatchImportRecordPost(requestParameters.batchImportDoubleMemberModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DoubleMemberApiDoubleMemberCheckRecordGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        doubleMemberCheckRecordGet(requestParameters: DoubleMemberApiDoubleMemberCheckRecordGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<DoubleMemberImportRecordDto> {
            return localVarFp.doubleMemberCheckRecordGet(requestParameters.telephoneEmail, requestParameters.name, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DoubleMemberApiDoubleMemberExportDoubleMemberPaymentGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        doubleMemberExportDoubleMemberPaymentGet(requestParameters: DoubleMemberApiDoubleMemberExportDoubleMemberPaymentGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Array<PaymentDto>> {
            return localVarFp.doubleMemberExportDoubleMemberPaymentGet(requestParameters.fromDate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        doubleMemberListAllRecordGet(options?: RawAxiosRequestConfig): AxiosPromise<Array<DoubleMemberImportRecordDto>> {
            return localVarFp.doubleMemberListAllRecordGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DoubleMemberApiDoubleMemberRegisterPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        doubleMemberRegisterPost(requestParameters: DoubleMemberApiDoubleMemberRegisterPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<UserDto> {
            return localVarFp.doubleMemberRegisterPost(requestParameters.doubleMemberRegisterModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DoubleMemberApiDoubleMemberSendSMSPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        doubleMemberSendSMSPost(requestParameters: DoubleMemberApiDoubleMemberSendSMSPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.doubleMemberSendSMSPost(requestParameters.findParams, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for doubleMemberBatchImportRecordPost operation in DoubleMemberApi.
 * @export
 * @interface DoubleMemberApiDoubleMemberBatchImportRecordPostRequest
 */
export interface DoubleMemberApiDoubleMemberBatchImportRecordPostRequest {
    /**
     * 
     * @type {BatchImportDoubleMemberModel}
     * @memberof DoubleMemberApiDoubleMemberBatchImportRecordPost
     */
    readonly batchImportDoubleMemberModel?: BatchImportDoubleMemberModel
}

/**
 * Request parameters for doubleMemberCheckRecordGet operation in DoubleMemberApi.
 * @export
 * @interface DoubleMemberApiDoubleMemberCheckRecordGetRequest
 */
export interface DoubleMemberApiDoubleMemberCheckRecordGetRequest {
    /**
     * 
     * @type {string}
     * @memberof DoubleMemberApiDoubleMemberCheckRecordGet
     */
    readonly telephoneEmail: string

    /**
     * 
     * @type {string}
     * @memberof DoubleMemberApiDoubleMemberCheckRecordGet
     */
    readonly name: string
}

/**
 * Request parameters for doubleMemberExportDoubleMemberPaymentGet operation in DoubleMemberApi.
 * @export
 * @interface DoubleMemberApiDoubleMemberExportDoubleMemberPaymentGetRequest
 */
export interface DoubleMemberApiDoubleMemberExportDoubleMemberPaymentGetRequest {
    /**
     * 
     * @type {string}
     * @memberof DoubleMemberApiDoubleMemberExportDoubleMemberPaymentGet
     */
    readonly fromDate?: string
}

/**
 * Request parameters for doubleMemberRegisterPost operation in DoubleMemberApi.
 * @export
 * @interface DoubleMemberApiDoubleMemberRegisterPostRequest
 */
export interface DoubleMemberApiDoubleMemberRegisterPostRequest {
    /**
     * 
     * @type {DoubleMemberRegisterModel}
     * @memberof DoubleMemberApiDoubleMemberRegisterPost
     */
    readonly doubleMemberRegisterModel?: DoubleMemberRegisterModel
}

/**
 * Request parameters for doubleMemberSendSMSPost operation in DoubleMemberApi.
 * @export
 * @interface DoubleMemberApiDoubleMemberSendSMSPostRequest
 */
export interface DoubleMemberApiDoubleMemberSendSMSPostRequest {
    /**
     * 
     * @type {FindParams}
     * @memberof DoubleMemberApiDoubleMemberSendSMSPost
     */
    readonly findParams?: FindParams
}

/**
 * DoubleMemberApi - object-oriented interface
 * @export
 * @class DoubleMemberApi
 * @extends {BaseAPI}
 */
export class DoubleMemberApi extends BaseAPI {
    /**
     * 
     * @param {DoubleMemberApiDoubleMemberBatchImportRecordPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DoubleMemberApi
     */
    public doubleMemberBatchImportRecordPost(requestParameters: DoubleMemberApiDoubleMemberBatchImportRecordPostRequest = {}, options?: RawAxiosRequestConfig) {
        return DoubleMemberApiFp(this.configuration).doubleMemberBatchImportRecordPost(requestParameters.batchImportDoubleMemberModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DoubleMemberApiDoubleMemberCheckRecordGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DoubleMemberApi
     */
    public doubleMemberCheckRecordGet(requestParameters: DoubleMemberApiDoubleMemberCheckRecordGetRequest, options?: RawAxiosRequestConfig) {
        return DoubleMemberApiFp(this.configuration).doubleMemberCheckRecordGet(requestParameters.telephoneEmail, requestParameters.name, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DoubleMemberApiDoubleMemberExportDoubleMemberPaymentGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DoubleMemberApi
     */
    public doubleMemberExportDoubleMemberPaymentGet(requestParameters: DoubleMemberApiDoubleMemberExportDoubleMemberPaymentGetRequest = {}, options?: RawAxiosRequestConfig) {
        return DoubleMemberApiFp(this.configuration).doubleMemberExportDoubleMemberPaymentGet(requestParameters.fromDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DoubleMemberApi
     */
    public doubleMemberListAllRecordGet(options?: RawAxiosRequestConfig) {
        return DoubleMemberApiFp(this.configuration).doubleMemberListAllRecordGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DoubleMemberApiDoubleMemberRegisterPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DoubleMemberApi
     */
    public doubleMemberRegisterPost(requestParameters: DoubleMemberApiDoubleMemberRegisterPostRequest = {}, options?: RawAxiosRequestConfig) {
        return DoubleMemberApiFp(this.configuration).doubleMemberRegisterPost(requestParameters.doubleMemberRegisterModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DoubleMemberApiDoubleMemberSendSMSPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DoubleMemberApi
     */
    public doubleMemberSendSMSPost(requestParameters: DoubleMemberApiDoubleMemberSendSMSPostRequest = {}, options?: RawAxiosRequestConfig) {
        return DoubleMemberApiFp(this.configuration).doubleMemberSendSMSPost(requestParameters.findParams, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PaymentApi - axios parameter creator
 * @export
 */
export const PaymentApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {GetPaymentUrlParams} [getPaymentUrlParams] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentGetPaymentUrlPost: async (getPaymentUrlParams?: GetPaymentUrlParams, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Payment/GetPaymentUrl`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getPaymentUrlParams, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentListPaymentGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Payment/ListPayment`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} pi 
         * @param {number} ps 
         * @param {string} [keywords] 
         * @param {PaymentGood} [paymentGood] 
         * @param {PaymentStatus} [paymentStatus] 
         * @param {string} [sorterKey] 
         * @param {boolean} [includeDeleted] 
         * @param {SorterOrder} [sorterOrder] 
         * @param {boolean} [isDelete] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentSearchGet: async (pi: number, ps: number, keywords?: string, paymentGood?: PaymentGood, paymentStatus?: PaymentStatus, sorterKey?: string, includeDeleted?: boolean, sorterOrder?: SorterOrder, isDelete?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pi' is not null or undefined
            assertParamExists('paymentSearchGet', 'pi', pi)
            // verify required parameter 'ps' is not null or undefined
            assertParamExists('paymentSearchGet', 'ps', ps)
            const localVarPath = `/Payment/Search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (keywords !== undefined) {
                localVarQueryParameter['Keywords'] = keywords;
            }

            if (paymentGood !== undefined) {
                localVarQueryParameter['PaymentGood'] = paymentGood;
            }

            if (paymentStatus !== undefined) {
                localVarQueryParameter['PaymentStatus'] = paymentStatus;
            }

            if (pi !== undefined) {
                localVarQueryParameter['Pi'] = pi;
            }

            if (ps !== undefined) {
                localVarQueryParameter['Ps'] = ps;
            }

            if (sorterKey !== undefined) {
                localVarQueryParameter['SorterKey'] = sorterKey;
            }

            if (includeDeleted !== undefined) {
                localVarQueryParameter['IncludeDeleted'] = includeDeleted;
            }

            if (sorterOrder !== undefined) {
                localVarQueryParameter['SorterOrder'] = sorterOrder;
            }

            if (isDelete !== undefined) {
                localVarQueryParameter['IsDelete'] = isDelete;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PaymentApi - functional programming interface
 * @export
 */
export const PaymentApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PaymentApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {GetPaymentUrlParams} [getPaymentUrlParams] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async paymentGetPaymentUrlPost(getPaymentUrlParams?: GetPaymentUrlParams, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaymentDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.paymentGetPaymentUrlPost(getPaymentUrlParams, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentApi.paymentGetPaymentUrlPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async paymentListPaymentGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PaymentDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.paymentListPaymentGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentApi.paymentListPaymentGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} pi 
         * @param {number} ps 
         * @param {string} [keywords] 
         * @param {PaymentGood} [paymentGood] 
         * @param {PaymentStatus} [paymentStatus] 
         * @param {string} [sorterKey] 
         * @param {boolean} [includeDeleted] 
         * @param {SorterOrder} [sorterOrder] 
         * @param {boolean} [isDelete] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async paymentSearchGet(pi: number, ps: number, keywords?: string, paymentGood?: PaymentGood, paymentStatus?: PaymentStatus, sorterKey?: string, includeDeleted?: boolean, sorterOrder?: SorterOrder, isDelete?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaymentDtoSearchResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.paymentSearchGet(pi, ps, keywords, paymentGood, paymentStatus, sorterKey, includeDeleted, sorterOrder, isDelete, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentApi.paymentSearchGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PaymentApi - factory interface
 * @export
 */
export const PaymentApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PaymentApiFp(configuration)
    return {
        /**
         * 
         * @param {PaymentApiPaymentGetPaymentUrlPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentGetPaymentUrlPost(requestParameters: PaymentApiPaymentGetPaymentUrlPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PaymentDto> {
            return localVarFp.paymentGetPaymentUrlPost(requestParameters.getPaymentUrlParams, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentListPaymentGet(options?: RawAxiosRequestConfig): AxiosPromise<Array<PaymentDto>> {
            return localVarFp.paymentListPaymentGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PaymentApiPaymentSearchGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentSearchGet(requestParameters: PaymentApiPaymentSearchGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<PaymentDtoSearchResponseDto> {
            return localVarFp.paymentSearchGet(requestParameters.pi, requestParameters.ps, requestParameters.keywords, requestParameters.paymentGood, requestParameters.paymentStatus, requestParameters.sorterKey, requestParameters.includeDeleted, requestParameters.sorterOrder, requestParameters.isDelete, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for paymentGetPaymentUrlPost operation in PaymentApi.
 * @export
 * @interface PaymentApiPaymentGetPaymentUrlPostRequest
 */
export interface PaymentApiPaymentGetPaymentUrlPostRequest {
    /**
     * 
     * @type {GetPaymentUrlParams}
     * @memberof PaymentApiPaymentGetPaymentUrlPost
     */
    readonly getPaymentUrlParams?: GetPaymentUrlParams
}

/**
 * Request parameters for paymentSearchGet operation in PaymentApi.
 * @export
 * @interface PaymentApiPaymentSearchGetRequest
 */
export interface PaymentApiPaymentSearchGetRequest {
    /**
     * 
     * @type {number}
     * @memberof PaymentApiPaymentSearchGet
     */
    readonly pi: number

    /**
     * 
     * @type {number}
     * @memberof PaymentApiPaymentSearchGet
     */
    readonly ps: number

    /**
     * 
     * @type {string}
     * @memberof PaymentApiPaymentSearchGet
     */
    readonly keywords?: string

    /**
     * 
     * @type {PaymentGood}
     * @memberof PaymentApiPaymentSearchGet
     */
    readonly paymentGood?: PaymentGood

    /**
     * 
     * @type {PaymentStatus}
     * @memberof PaymentApiPaymentSearchGet
     */
    readonly paymentStatus?: PaymentStatus

    /**
     * 
     * @type {string}
     * @memberof PaymentApiPaymentSearchGet
     */
    readonly sorterKey?: string

    /**
     * 
     * @type {boolean}
     * @memberof PaymentApiPaymentSearchGet
     */
    readonly includeDeleted?: boolean

    /**
     * 
     * @type {SorterOrder}
     * @memberof PaymentApiPaymentSearchGet
     */
    readonly sorterOrder?: SorterOrder

    /**
     * 
     * @type {boolean}
     * @memberof PaymentApiPaymentSearchGet
     */
    readonly isDelete?: boolean
}

/**
 * PaymentApi - object-oriented interface
 * @export
 * @class PaymentApi
 * @extends {BaseAPI}
 */
export class PaymentApi extends BaseAPI {
    /**
     * 
     * @param {PaymentApiPaymentGetPaymentUrlPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentApi
     */
    public paymentGetPaymentUrlPost(requestParameters: PaymentApiPaymentGetPaymentUrlPostRequest = {}, options?: RawAxiosRequestConfig) {
        return PaymentApiFp(this.configuration).paymentGetPaymentUrlPost(requestParameters.getPaymentUrlParams, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentApi
     */
    public paymentListPaymentGet(options?: RawAxiosRequestConfig) {
        return PaymentApiFp(this.configuration).paymentListPaymentGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PaymentApiPaymentSearchGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentApi
     */
    public paymentSearchGet(requestParameters: PaymentApiPaymentSearchGetRequest, options?: RawAxiosRequestConfig) {
        return PaymentApiFp(this.configuration).paymentSearchGet(requestParameters.pi, requestParameters.ps, requestParameters.keywords, requestParameters.paymentGood, requestParameters.paymentStatus, requestParameters.sorterKey, requestParameters.includeDeleted, requestParameters.sorterOrder, requestParameters.isDelete, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * SystemApi - axios parameter creator
 * @export
 */
export const SystemApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        systemGetGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/System/Get`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SaveSystemConfigParams} [saveSystemConfigParams] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        systemSavePost: async (saveSystemConfigParams?: SaveSystemConfigParams, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/System/Save`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(saveSystemConfigParams, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SystemApi - functional programming interface
 * @export
 */
export const SystemApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SystemApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async systemGetGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SystemConfig>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.systemGetGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SystemApi.systemGetGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {SaveSystemConfigParams} [saveSystemConfigParams] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async systemSavePost(saveSystemConfigParams?: SaveSystemConfigParams, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SystemConfig>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.systemSavePost(saveSystemConfigParams, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SystemApi.systemSavePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SystemApi - factory interface
 * @export
 */
export const SystemApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SystemApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        systemGetGet(options?: RawAxiosRequestConfig): AxiosPromise<SystemConfig> {
            return localVarFp.systemGetGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SystemApiSystemSavePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        systemSavePost(requestParameters: SystemApiSystemSavePostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<SystemConfig> {
            return localVarFp.systemSavePost(requestParameters.saveSystemConfigParams, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for systemSavePost operation in SystemApi.
 * @export
 * @interface SystemApiSystemSavePostRequest
 */
export interface SystemApiSystemSavePostRequest {
    /**
     * 
     * @type {SaveSystemConfigParams}
     * @memberof SystemApiSystemSavePost
     */
    readonly saveSystemConfigParams?: SaveSystemConfigParams
}

/**
 * SystemApi - object-oriented interface
 * @export
 * @class SystemApi
 * @extends {BaseAPI}
 */
export class SystemApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SystemApi
     */
    public systemGetGet(options?: RawAxiosRequestConfig) {
        return SystemApiFp(this.configuration).systemGetGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SystemApiSystemSavePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SystemApi
     */
    public systemSavePost(requestParameters: SystemApiSystemSavePostRequest = {}, options?: RawAxiosRequestConfig) {
        return SystemApiFp(this.configuration).systemSavePost(requestParameters.saveSystemConfigParams, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * UserApi - axios parameter creator
 * @export
 */
export const UserApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userFindGet: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('userFindGet', 'id', id)
            const localVarPath = `/User/Find`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (id !== undefined) {
                localVarQueryParameter['Id'] = id;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ImportUserParams} [importUserParams] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userImportUserPost: async (importUserParams?: ImportUserParams, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/User/ImportUser`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(importUserParams, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userListManagerGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/User/ListManager`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {RegisterParams} [registerParams] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userRegisterPost: async (registerParams?: RegisterParams, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/User/Register`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(registerParams, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {RequestSmsCodeParams} [requestSmsCodeParams] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userRequestSmsCodePost: async (requestSmsCodeParams?: RequestSmsCodeParams, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/User/RequestSmsCode`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestSmsCodeParams, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SaveManagerParams} [saveManagerParams] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userSaveManagerPost: async (saveManagerParams?: SaveManagerParams, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/User/SaveManager`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(saveManagerParams, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SavePersonalApproveParams} [savePersonalApproveParams] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userSavePersonalApprovePost: async (savePersonalApproveParams?: SavePersonalApproveParams, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/User/SavePersonalApprove`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(savePersonalApproveParams, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} pi 
         * @param {number} ps 
         * @param {string} [keywords] 
         * @param {string} [sorterKey] 
         * @param {boolean} [includeDeleted] 
         * @param {SorterOrder} [sorterOrder] 
         * @param {boolean} [isDelete] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userSearchGet: async (pi: number, ps: number, keywords?: string, sorterKey?: string, includeDeleted?: boolean, sorterOrder?: SorterOrder, isDelete?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pi' is not null or undefined
            assertParamExists('userSearchGet', 'pi', pi)
            // verify required parameter 'ps' is not null or undefined
            assertParamExists('userSearchGet', 'ps', ps)
            const localVarPath = `/User/Search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (keywords !== undefined) {
                localVarQueryParameter['Keywords'] = keywords;
            }

            if (pi !== undefined) {
                localVarQueryParameter['Pi'] = pi;
            }

            if (ps !== undefined) {
                localVarQueryParameter['Ps'] = ps;
            }

            if (sorterKey !== undefined) {
                localVarQueryParameter['SorterKey'] = sorterKey;
            }

            if (includeDeleted !== undefined) {
                localVarQueryParameter['IncludeDeleted'] = includeDeleted;
            }

            if (sorterOrder !== undefined) {
                localVarQueryParameter['SorterOrder'] = sorterOrder;
            }

            if (isDelete !== undefined) {
                localVarQueryParameter['IsDelete'] = isDelete;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UserApi - functional programming interface
 * @export
 */
export const UserApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UserApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userFindGet(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userFindGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApi.userFindGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {ImportUserParams} [importUserParams] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userImportUserPost(importUserParams?: ImportUserParams, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userImportUserPost(importUserParams, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApi.userImportUserPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userListManagerGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<UserDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userListManagerGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApi.userListManagerGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {RegisterParams} [registerParams] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userRegisterPost(registerParams?: RegisterParams, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TokenDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userRegisterPost(registerParams, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApi.userRegisterPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {RequestSmsCodeParams} [requestSmsCodeParams] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userRequestSmsCodePost(requestSmsCodeParams?: RequestSmsCodeParams, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userRequestSmsCodePost(requestSmsCodeParams, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApi.userRequestSmsCodePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {SaveManagerParams} [saveManagerParams] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userSaveManagerPost(saveManagerParams?: SaveManagerParams, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userSaveManagerPost(saveManagerParams, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApi.userSaveManagerPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {SavePersonalApproveParams} [savePersonalApproveParams] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userSavePersonalApprovePost(savePersonalApproveParams?: SavePersonalApproveParams, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userSavePersonalApprovePost(savePersonalApproveParams, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApi.userSavePersonalApprovePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} pi 
         * @param {number} ps 
         * @param {string} [keywords] 
         * @param {string} [sorterKey] 
         * @param {boolean} [includeDeleted] 
         * @param {SorterOrder} [sorterOrder] 
         * @param {boolean} [isDelete] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userSearchGet(pi: number, ps: number, keywords?: string, sorterKey?: string, includeDeleted?: boolean, sorterOrder?: SorterOrder, isDelete?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserDtoSearchResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userSearchGet(pi, ps, keywords, sorterKey, includeDeleted, sorterOrder, isDelete, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApi.userSearchGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * UserApi - factory interface
 * @export
 */
export const UserApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UserApiFp(configuration)
    return {
        /**
         * 
         * @param {UserApiUserFindGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userFindGet(requestParameters: UserApiUserFindGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<UserDto> {
            return localVarFp.userFindGet(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UserApiUserImportUserPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userImportUserPost(requestParameters: UserApiUserImportUserPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<UserDto> {
            return localVarFp.userImportUserPost(requestParameters.importUserParams, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userListManagerGet(options?: RawAxiosRequestConfig): AxiosPromise<Array<UserDto>> {
            return localVarFp.userListManagerGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UserApiUserRegisterPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userRegisterPost(requestParameters: UserApiUserRegisterPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<TokenDto> {
            return localVarFp.userRegisterPost(requestParameters.registerParams, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UserApiUserRequestSmsCodePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userRequestSmsCodePost(requestParameters: UserApiUserRequestSmsCodePostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.userRequestSmsCodePost(requestParameters.requestSmsCodeParams, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UserApiUserSaveManagerPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userSaveManagerPost(requestParameters: UserApiUserSaveManagerPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<UserDto> {
            return localVarFp.userSaveManagerPost(requestParameters.saveManagerParams, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UserApiUserSavePersonalApprovePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userSavePersonalApprovePost(requestParameters: UserApiUserSavePersonalApprovePostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<UserDto> {
            return localVarFp.userSavePersonalApprovePost(requestParameters.savePersonalApproveParams, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UserApiUserSearchGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userSearchGet(requestParameters: UserApiUserSearchGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<UserDtoSearchResponseDto> {
            return localVarFp.userSearchGet(requestParameters.pi, requestParameters.ps, requestParameters.keywords, requestParameters.sorterKey, requestParameters.includeDeleted, requestParameters.sorterOrder, requestParameters.isDelete, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for userFindGet operation in UserApi.
 * @export
 * @interface UserApiUserFindGetRequest
 */
export interface UserApiUserFindGetRequest {
    /**
     * 
     * @type {number}
     * @memberof UserApiUserFindGet
     */
    readonly id: number
}

/**
 * Request parameters for userImportUserPost operation in UserApi.
 * @export
 * @interface UserApiUserImportUserPostRequest
 */
export interface UserApiUserImportUserPostRequest {
    /**
     * 
     * @type {ImportUserParams}
     * @memberof UserApiUserImportUserPost
     */
    readonly importUserParams?: ImportUserParams
}

/**
 * Request parameters for userRegisterPost operation in UserApi.
 * @export
 * @interface UserApiUserRegisterPostRequest
 */
export interface UserApiUserRegisterPostRequest {
    /**
     * 
     * @type {RegisterParams}
     * @memberof UserApiUserRegisterPost
     */
    readonly registerParams?: RegisterParams
}

/**
 * Request parameters for userRequestSmsCodePost operation in UserApi.
 * @export
 * @interface UserApiUserRequestSmsCodePostRequest
 */
export interface UserApiUserRequestSmsCodePostRequest {
    /**
     * 
     * @type {RequestSmsCodeParams}
     * @memberof UserApiUserRequestSmsCodePost
     */
    readonly requestSmsCodeParams?: RequestSmsCodeParams
}

/**
 * Request parameters for userSaveManagerPost operation in UserApi.
 * @export
 * @interface UserApiUserSaveManagerPostRequest
 */
export interface UserApiUserSaveManagerPostRequest {
    /**
     * 
     * @type {SaveManagerParams}
     * @memberof UserApiUserSaveManagerPost
     */
    readonly saveManagerParams?: SaveManagerParams
}

/**
 * Request parameters for userSavePersonalApprovePost operation in UserApi.
 * @export
 * @interface UserApiUserSavePersonalApprovePostRequest
 */
export interface UserApiUserSavePersonalApprovePostRequest {
    /**
     * 
     * @type {SavePersonalApproveParams}
     * @memberof UserApiUserSavePersonalApprovePost
     */
    readonly savePersonalApproveParams?: SavePersonalApproveParams
}

/**
 * Request parameters for userSearchGet operation in UserApi.
 * @export
 * @interface UserApiUserSearchGetRequest
 */
export interface UserApiUserSearchGetRequest {
    /**
     * 
     * @type {number}
     * @memberof UserApiUserSearchGet
     */
    readonly pi: number

    /**
     * 
     * @type {number}
     * @memberof UserApiUserSearchGet
     */
    readonly ps: number

    /**
     * 
     * @type {string}
     * @memberof UserApiUserSearchGet
     */
    readonly keywords?: string

    /**
     * 
     * @type {string}
     * @memberof UserApiUserSearchGet
     */
    readonly sorterKey?: string

    /**
     * 
     * @type {boolean}
     * @memberof UserApiUserSearchGet
     */
    readonly includeDeleted?: boolean

    /**
     * 
     * @type {SorterOrder}
     * @memberof UserApiUserSearchGet
     */
    readonly sorterOrder?: SorterOrder

    /**
     * 
     * @type {boolean}
     * @memberof UserApiUserSearchGet
     */
    readonly isDelete?: boolean
}

/**
 * UserApi - object-oriented interface
 * @export
 * @class UserApi
 * @extends {BaseAPI}
 */
export class UserApi extends BaseAPI {
    /**
     * 
     * @param {UserApiUserFindGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public userFindGet(requestParameters: UserApiUserFindGetRequest, options?: RawAxiosRequestConfig) {
        return UserApiFp(this.configuration).userFindGet(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UserApiUserImportUserPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public userImportUserPost(requestParameters: UserApiUserImportUserPostRequest = {}, options?: RawAxiosRequestConfig) {
        return UserApiFp(this.configuration).userImportUserPost(requestParameters.importUserParams, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public userListManagerGet(options?: RawAxiosRequestConfig) {
        return UserApiFp(this.configuration).userListManagerGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UserApiUserRegisterPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public userRegisterPost(requestParameters: UserApiUserRegisterPostRequest = {}, options?: RawAxiosRequestConfig) {
        return UserApiFp(this.configuration).userRegisterPost(requestParameters.registerParams, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UserApiUserRequestSmsCodePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public userRequestSmsCodePost(requestParameters: UserApiUserRequestSmsCodePostRequest = {}, options?: RawAxiosRequestConfig) {
        return UserApiFp(this.configuration).userRequestSmsCodePost(requestParameters.requestSmsCodeParams, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UserApiUserSaveManagerPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public userSaveManagerPost(requestParameters: UserApiUserSaveManagerPostRequest = {}, options?: RawAxiosRequestConfig) {
        return UserApiFp(this.configuration).userSaveManagerPost(requestParameters.saveManagerParams, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UserApiUserSavePersonalApprovePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public userSavePersonalApprovePost(requestParameters: UserApiUserSavePersonalApprovePostRequest = {}, options?: RawAxiosRequestConfig) {
        return UserApiFp(this.configuration).userSavePersonalApprovePost(requestParameters.savePersonalApproveParams, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UserApiUserSearchGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public userSearchGet(requestParameters: UserApiUserSearchGetRequest, options?: RawAxiosRequestConfig) {
        return UserApiFp(this.configuration).userSearchGet(requestParameters.pi, requestParameters.ps, requestParameters.keywords, requestParameters.sorterKey, requestParameters.includeDeleted, requestParameters.sorterOrder, requestParameters.isDelete, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * WeatherForecastApi - axios parameter creator
 * @export
 */
export const WeatherForecastApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWeatherForecast: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/WeatherForecast`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * WeatherForecastApi - functional programming interface
 * @export
 */
export const WeatherForecastApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = WeatherForecastApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWeatherForecast(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<WeatherForecast>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWeatherForecast(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WeatherForecastApi.getWeatherForecast']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * WeatherForecastApi - factory interface
 * @export
 */
export const WeatherForecastApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = WeatherForecastApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWeatherForecast(options?: RawAxiosRequestConfig): AxiosPromise<Array<WeatherForecast>> {
            return localVarFp.getWeatherForecast(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * WeatherForecastApi - object-oriented interface
 * @export
 * @class WeatherForecastApi
 * @extends {BaseAPI}
 */
export class WeatherForecastApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WeatherForecastApi
     */
    public getWeatherForecast(options?: RawAxiosRequestConfig) {
        return WeatherForecastApiFp(this.configuration).getWeatherForecast(options).then((request) => request(this.axios, this.basePath));
    }
}



